const API = `${process.env.REACT_APP_BACKEND_URL}/api/klarys`;

export const klarysUrl = (p) => `${API}${p}`;

export async function streamKlarys(path, headers, body, onEvent) {
  const res = await fetch(klarysUrl(path), {
    method: 'POST',
    headers: { ...headers, 'Content-Type': 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok || !res.body) {
    let detail = `Erreur ${res.status}`;
    try { detail = (await res.json()).detail || detail; } catch (e) { /* réponse non JSON */ }
    throw new Error(detail);
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = '';
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const parts = buf.split('\n\n');
    buf = parts.pop();
    parts.forEach((p) => {
      const line = p.split('\n').find((l) => l.startsWith('data: '));
      if (line) onEvent(JSON.parse(line.slice(6)));
    });
  }
}

export const visibleText = (t) => {
  const i = (t || '').indexOf('<<ACTION>>');
  return (i >= 0 ? t.slice(0, i) : t || '').trim();
};

let audioCourant = null;

export const arreterLecture = () => {
  if (audioCourant) { audioCourant.pause(); audioCourant = null; }
};

export async function lireTexte(texte, headers) {
  arreterLecture();
  const res = await fetch(klarysUrl('/lire'), { method: 'POST', headers: { ...headers, 'Content-Type': 'application/json' }, body: JSON.stringify({ texte }) });
  if (!res.ok) {
    let detail = 'Lecture vocale impossible';
    try { detail = (await res.json()).detail || detail; } catch (e) { /* réponse non JSON */ }
    throw new Error(detail);
  }
  const url = URL.createObjectURL(await res.blob());
  const audio = new Audio(url);
  audioCourant = audio;
  await new Promise((resolve, reject) => {
    audio.onended = resolve;
    audio.onpause = resolve;
    audio.onerror = reject;
    audio.play().catch(reject);
  });
  URL.revokeObjectURL(url);
  if (audioCourant === audio) audioCourant = null;
}
